import { render, staticRenderFns } from "./TickerAdminListCompanies.vue?vue&type=template&id=42f56d57&scoped=true"
import script from "./TickerAdminListCompanies.vue?vue&type=script&lang=js"
export * from "./TickerAdminListCompanies.vue?vue&type=script&lang=js"
import style0 from "./TickerAdminListCompanies.vue?vue&type=style&index=0&id=42f56d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f56d57",
  null
  
)

export default component.exports